import React, { useMemo } from 'react';
import { OptionKey, SelectDropdown } from '@common-fe/common-fe';

import { ALL_OPTION_KEY } from '@/common/constants';
import { useSelectAllHandler } from '@/modules/core';
import { CARD_STATUSES_OPTIONS } from '@/modules/Reports/report.types';

// FiservCardStatusEnum
interface Props {
  testId?: string;
  values: OptionKey[];
  disabled?: boolean;
  onChangeValues: (value: OptionKey[]) => void;
}
const CardStatusSelector: React.FC<Props> = ({
  testId = 'card-status_selector',
  disabled,
  values,
  onChangeValues,
}) => {
  const currentValue = useMemo(() => {
    if (!values.length && !disabled) {
      return [ALL_OPTION_KEY];
    }
    return values;
  }, [disabled, values]);

  const handleChangeValue = useSelectAllHandler(values, onChangeValues);

  return (
    <SelectDropdown
      key="card-status_selector"
      ellipsisMode
      disabled={disabled}
      activeTitle
      testId={testId}
      options={CARD_STATUSES_OPTIONS}
      values={currentValue}
      onChangeValues={handleChangeValue}
      prefix="Card status"
      id="card-status_selector"
      name="card-status_selector"
      allMode
    />
  );
};

export default CardStatusSelector;
